<app-loader *ngIf="isDisabled"></app-loader>
<div class="modal-header">
    <!-- <p>From Date :{{ LeaveFromDate }} - To Date :{{ LeaveToDate }}</p> -->
    <p>Balance as on date : {{ LeaveToDate }}</p>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
        <thead class="table-light">
            <tr>
                <th scope="col" style="width: 5px;">#</th>
                <th style="width: 100px;">Date</th>
                <th style="width: 100px;">In Time</th>
                <th style="width: 100px;">Out Time</th>
                <th style="width: 20px;">Remark</th>
                <th style="width: 100px;">Balance</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let TableData of CompoffHistory; let i = index">
                <th scope="row" style="width: 5px;">{{i+1}}</th>
                <td style="width: 100px;">{{TableData['AttendanceDate'] | date : 'dd MMM yyyy' }}</td>
                <td style="width: 100px;">{{TableData['InTime'] | date : 'dd MMM yyyy HH:mm' }}</td>
                <td style="width: 100px;">{{TableData['OutTime'] | date : 'dd MMM yyyy HH:mm' }}</td>
                <td style="width: 20px;">{{TableData['AttendanceRemark']}}</td>
                <td style="width: 100px;">{{TableData['Balanced']}}</td>
            </tr>
        </tbody>
    </table>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="close()"><i class="bi bi-x"
            *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Close':'Loading...'}}</button>
</div>